angular.module('gym.privacy_policies').controller('UserPolicyResponsesCtrl', ["$scope", "$rootScope", "$window", "$http", "loadingAnimation", "flash", "GTMService", "ngTableParams", function($scope, $rootScope, $window, $http, loadingAnimation, flash, GTMService, ngTableParams) {
  var gym;
  GTMService.trackPage('User Consent');
  gym = $rootScope.gym;
  return $scope.tableParams = new ngTableParams({
    page: 1,
    count: 1000
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      var url;
      loadingAnimation.show();
      url = `/gyms/${gym.id}/user_policy_responses`;
      return $http.get(url, {
        params: $params.url()
      }).then(function(response) {
        $params.total(response.data.total);
        $defer.resolve(response.data.collection);
        return loadingAnimation.hide();
      });
    }
  });
}]);
